import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { HeaderService } from "@app/components/header/header.service";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { SpinnerService } from "@app/services/spinner.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PrintService } from "@app/services/Print.service";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { Component, Inject } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { MatDialog } from "@angular/material/dialog";
import { AppInitService } from "@app/services/AppInit.service";
import { Router } from "@angular/router";

export type $stateParams = {
    paymentConfirmationNumber: string // "123",
    paymentId: string // "1"
    email: string
    paymentRequest: PaymentRequest
}

@Component({
    selector: 'app-payment-cancel',
    template: require('./paymentCancel.html')
})
export class PaymentCancelComponent {
    paymentRequest: PaymentRequest;
    email: string;
    paymentConfirmationNumber: any;
    paymentId: string;
    $stateParams: $stateParams;

    constructor(
        @Inject(WindowToken) private $window,
        @Inject(PrintService) private printService: PrintService,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(PaymentStore) private paymentStore: PaymentStore,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(AppInitService) private appInitService: AppInitService,
        @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state as $stateParams;
        }

        headerService.setDisplayRightContent(true);

        if (this.$stateParams
            && this.$stateParams.paymentConfirmationNumber
            && this.$stateParams.paymentId
            && this.$stateParams.email
            && this.$stateParams.paymentRequest
        ) {
            this.paymentConfirmationNumber = this.$stateParams.paymentConfirmationNumber;
            this.paymentId = this.$stateParams.paymentId;
            this.email = this.$stateParams.email;
            this.paymentRequest = this.$stateParams.paymentRequest;
        }
    }

    goToPropertiesPage() {
        this.paymentStore.clearAll();
        this.$window.location.replace("/registered/#/properties");
    }

    clickPrint() {
        this.printService.print("Cancelled Payment", "Clicked print button")
    }
}
